/* Vídeo pequeno da coluna Detalhes do PDP. Ver sections/description-details.liquid.
   Só carrega o arquivo quando o vídeo entra na tela; pausa quando sai. Com "reduzir movimento"
   ou economia de dados, fica na capa (poster). */
if (!customElements.get('product-detail-video')) {
  customElements.define(
    'product-detail-video',
    class ProductDetailVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video || !this.dataset.src) return;
        this.video.addEventListener('play', () => this.classList.add('is-playing'));
        this.video.addEventListener('pause', () => this.classList.remove('is-playing'));
        // Toque/clique (ou Enter/espaço) alterna play e pausa; é o único jeito de ver o vídeo com "reduzir movimento".
        this.addEventListener('click', () => this.toggle());
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.toggle();
          }
        });
        if (!this.canPlay()) return;
        if (!('IntersectionObserver' in window)) {
          this.start();
          return;
        }
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.25) this.start();
              else if (this.started && !this.video.paused) this.video.pause();
            });
          },
          { threshold: [0, 0.25, 1] }
        );
        this.observer.observe(this);
      }

      canPlay() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
        const conn = navigator.connection;
        if (conn && conn.saveData) return false;
        return true;
      }

      start() {
        if (!this.started) {
          this.started = true;
          this.video.addEventListener(
            'error',
            () => {
              const fallback = this.dataset.fallbackSrc;
              if (!fallback || this.video.src === fallback) return;
              this.video.src = fallback;
              this.video.load();
              this.video.play().catch(() => {});
            },
            { once: true }
          );
          this.video.src = this.dataset.src;
          this.video.load();
        }
        this.video.play().catch(() => {});
      }

      toggle() {
        if (!this.started || this.video.paused) this.start();
        else this.video.pause();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
